import { createTestId, TestIDSet } from './createTestId'
/**
 * Selectors for elements in the primary nav bar
 */
export const navigation = {
  loginButton: createTestId('profile-button-login-button'),
  profileMenuIcon: createTestId('profile-button-profile-menu-icon-button'),
  profileMenuButton: createTestId('profile-button-profile-menu-button'),
  profileMenuApplicationsItem: createTestId('profile-button-profile-menu-applications-item'),
  profileMenuAccountInfoItem: createTestId('profile-button-profile-menu-account-info-item'),
  profileMenuWalletInfoItem: createTestId('profile-button-profile-menu-wallet-info-item'),
  profileMenuApplicationsLink: createTestId('profile-button-profile-menu-applications-link'),
  profileMenuAccountInfoLink: createTestId('profile-button-profile-menu-account-info-link'),
  profileMenuWalletInfoLink: createTestId('profile-button-profile-menu-wallet-info-link'),
  logoutMenuItem: createTestId('profile-button-logout-menu-item'),
}

/**
 * Selectors for elements on the Home page
 */
export const homePage = {
  discoverButton: createTestId('discover-button'),
}

/**
 * Selectors for elements on the discover page
 */
export const discoverPage = {
  featuredCohortsContainer: createTestId('featured-cohort-container'),
  getFilterButtonByCategoryName: (name: string): TestIDSet => {
    name = name.replace(/\s+/g, '-').toLowerCase()

    return createTestId(`${name}-category-filter-button`)
  },
  getCohortTagByCategoryName: (name: string): TestIDSet => {
    name = name.replace(/\s+/g, '-').toLowerCase()

    return createTestId(`${name}-cohort-tag`)
  },
}

/**
 * Selectors for elements on the Create Application Page
 */
export const createApplicationPage = {
  headerProfileSegment: createTestId('header-profile-segment'),
  submitButton: createTestId('application-create-page-submit-button'),
  videoRemoveIcon: createTestId('video-remove-icon'),
  videoPlayer: createTestId('video-player'),
}

/**
 * Selectors for elements on the How to record video section
 */
export const howToRecordVideoSection = {
  step1Title: createTestId('step-1-title'),
  step1Subtitle: createTestId('step-1-subtitle'),
  step2Title: createTestId('step-2-title'),
  step2Subtitle: createTestId('step-2-subtitle'),
  step3Title: createTestId('step-3-title'),
  step3Subtitle: createTestId('step-3-subtitle'),
  step4Title: createTestId('step-4-title'),
  step4Subtitle: createTestId('step-4-subtitle'),
}

/**
 * Selectors for elements on the Scholarship Page
 */
export const scholarship = {
  audition: createTestId('audition-submit-button'),
  upvote: createTestId('upvote-submit-button'),
}

/**
 * Selectors for elements on the Username Page
 */
export const usernamePage = {
  expertGreetingSegment: createTestId('expert-greeting-segment'),
  profileContainer: createTestId('profile-segment'),
  auditionNowBtn: createTestId('audition-now-btn'),
  countdownSegment: createTestId('countdown-segment'),
  timelineSegment: createTestId('timeline-segment'),
}

/**
 * Selectors for elements on the Expert Page
 */
export const expertPage = {
  headerContainer: createTestId('header-container'),
  panelistsSegment: createTestId('panelists-segment'),
  applicationStartBtn: createTestId('application-start-btn'),
  cohortDescriptionSegment: createTestId('cohort-description-segment'),
  expertBioSegment: createTestId('expert-bio-segment'),
  whatToSendSegment: createTestId('what-to-send-segment'),
  whatYouReceiveSegment: createTestId('what-you-receive-segment'),
  scholarshipApplicationBtn: createTestId('scholarship-application-btn'),
  paidApplicationBtn: createTestId('paid-application-btn'),
  spotsLeftInfo: createTestId('spots-left-info'),
  applicationDeadlineInfo: createTestId('application-deadline-info'),
  sampleVideosContainer: createTestId('sample-videos-container'),
  rulesSection: createTestId('rules-section'),
  recentAuditionsContainer: createTestId('recent-auditions-container'),
  waitlistContainer: createTestId('waitlist-container'),
}

/**
 * Selectors for elements on the Application List Page
 */
export const applicationListPage = {
  applicationSegment: createTestId('application-segment'),
}

/**
 * Selectors for elements on the Application Detail Page
 */
export const applicationDetailPage = {
  mainContainer: createTestId('application-main-container'),
  applicationTitleSegment: createTestId('application-title-segment'),
  coverSegment: createTestId('application-cover-segment'),
  progressSegment: createTestId('progress-segment'),
  answerVideoSegment: createTestId('answer-video-segment'),
  answerEssaySegment: createTestId('answer-essay-segment'),
  reviewSegment: createTestId('review-segment'),
}

export const userProfileForm = {
  nameInput: createTestId('name-input'),
  usernameInput: createTestId('username-input'),
  phoneInput: createTestId('phone-input'),
  emailInput: createTestId('email-input'),
}

export const applicationSummaryAndPaymentPage = {
  studentCardSegment: createTestId('student-card-segment'),
  checkoutFormSegment: createTestId('checkout-form-segment'),
  cardNumberContainer: createTestId('card-number-container'),
  cardExpiryContainer: createTestId('card-expiry-container'),
  cardCvcContainer: createTestId('card-cvc-container'),
  applicationPriceInfoSegment: createTestId('application-price-info-segment'),
  scholarshipInfoContainer: createTestId('scholarship-info-container'),
  cardPayAndSubmitButton: createTestId('card-pay-and-submit-button'),
  creditsPayAndSubmitButton: createTestId('credits-pay-and-submit-button'),
  scholarshipSubmitButton: createTestId('scholarship-submit-button'),
  acceptTOSCheckbox: createTestId('accept-tos-checkbox'),
  acceptContentTOSCheckbox: createTestId('accept-content-tos-checkbox'),
}

export const studentApplication = {
  studentLink: createTestId('student-application-student-link'),
  videoDescription: createTestId('student-application-video-description'),
  upVoteButton: createTestId('student-application-up-vote-button'),
}

export const feedHomePage = {
  exploreOpportunities: createTestId('feedhomepage-explore-opportunities'),
  getExpertName: (name: string): TestIDSet => {
    name = name.replace(/\s+/g, '-').toLowerCase()
    return createTestId(`${name}-feedhomepage-expert-name`)
  },
}

export const refundModal = {
  initiateRefund: createTestId('refund-modal-initiate-refund'),
  successRefund: createTestId('refund-modal-success-refund'),
  errorRefund: createTestId('refund-modal-error-refund'),
  confirmRefundButton: createTestId('refund-modal-confirm-refund-button'),
}
